/* Sorbly — interacciones propias. Cada init comprueba si su elemento existe. */
(function () {
  // Varias secciones cargan este archivo: solo debe ejecutarse una vez.
  if (window.__sbScripts) return;
  window.__sbScripts = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.sb-reveal:not(.sb-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-sb-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var fuerza = parseFloat(img.getAttribute('data-sb-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var y = (r.top + r.height / 2 - window.innerHeight / 2) * (fuerza / 100) * -0.4;
        img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + (1 + fuerza / 400) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function formatMoney(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var sinDec = Math.round(cents / 100).toString();
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto(root) {
    var datosEl = root.querySelector('[data-sb-producto-json]');
    if (!datosEl) return;
    var datos = JSON.parse(datosEl.textContent);
    var variantes = datos.variants;
    var form = root.querySelector('form[action*="/cart/add"]');
    var inputId = form.querySelector('input[name="id"]');
    var boton = root.querySelector('[data-sb-add]');
    var botonTxt = boton.querySelector('[data-sb-add-texto]');
    var ahora = root.querySelectorAll('[data-sb-precio]');
    var antes = root.querySelectorAll('[data-sb-precio-antes]');
    var ahorro = root.querySelectorAll('[data-sb-ahorro]');
    var errorEl = root.querySelector('[data-sb-error]');

    // Galería
    var principal = root.querySelector('[data-sb-principal]');
    var minis = Array.prototype.slice.call(root.querySelectorAll('[data-sb-mini]'));
    var actual = 0;
    function verFoto(i) {
      if (!minis.length || !principal) return;
      actual = (i + minis.length) % minis.length;
      var m = minis[actual];
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = m.getAttribute('data-src');
        principal.srcset = m.getAttribute('data-srcset') || '';
        principal.alt = m.getAttribute('data-alt') || '';
        principal.style.opacity = 1;
      }, 180);
      minis.forEach(function (x, j) { x.classList.toggle('is-active', j === actual); });
      m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { verFoto(i); }); });
    var prev = root.querySelector('[data-sb-prev]');
    var next = root.querySelector('[data-sb-next]');
    if (prev) prev.addEventListener('click', function () { verFoto(actual - 1); });
    if (next) next.addEventListener('click', function () { verFoto(actual + 1); });

    // Variantes
    function pintar(v) {
      if (!v) {
        boton.disabled = true;
        botonTxt.textContent = datos.txtNoDisponible;
        return;
      }
      inputId.value = v.id;
      ahora.forEach(function (el) { el.textContent = formatMoney(v.price, datos.formato); });
      var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
      antes.forEach(function (el) { el.textContent = hayAntes ? formatMoney(v.compare_at_price, datos.formato) : ''; el.hidden = !hayAntes; });
      ahorro.forEach(function (el) {
        el.hidden = !hayAntes;
        if (hayAntes) el.textContent = datos.txtAhorro.replace('[ahorro]', formatMoney(v.compare_at_price - v.price, datos.formato));
      });
      boton.disabled = !v.available;
      botonTxt.textContent = v.available ? datos.txtComprar : datos.txtAgotado;
      root.querySelectorAll('[data-sb-opcion-valor]').forEach(function (el) {
        el.textContent = v.options[parseInt(el.getAttribute('data-sb-opcion-valor'), 10)];
      });
      if (v.featured_media_index != null && minis.length) verFoto(v.featured_media_index);
      if (datos.actualizarUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-sb-opcion] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var elegidas = [];
        root.querySelectorAll('[data-sb-opcion]').forEach(function (grupo) {
          var c = grupo.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        pintar(v);
      });
    });

    // Cantidad
    var cant = root.querySelector('[data-sb-cantidad]');
    if (cant) {
      root.querySelectorAll('[data-sb-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-sb-cant'), 10);
          cant.value = Math.max(1, n);
        });
      });
    }

    // Añadir al carrito (abre el cajón del carrito de Dawn si existe)
    form.addEventListener('submit', function (ev) {
      var drawer = document.querySelector('cart-drawer');
      if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return;
      ev.preventDefault();
      if (errorEl) errorEl.hidden = true;
      boton.disabled = true;
      var fd = new FormData(form);
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) {
          if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      }).catch(function () { form.submit(); })
        .finally(function () { boton.disabled = false; });
    });

    // Barra fija en móvil
    var barra = root.querySelector('[data-sb-barra]');
    if (barra && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        barra.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(boton);
      barra.querySelector('button').addEventListener('click', function () {
        boton.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  function init() {
    initReveal();
    initParallax();
    document.querySelectorAll('[data-sb-producto]').forEach(initProducto);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
